import React from "react";
import ErrorIcon from "@material-ui/icons/ErrorOutline";
import GenericView from "./GenericView.js";

/**
 * Error 404 view
 *
 * This is the generic 404 screen.
 *
 * @package BrandTracker
 * @subpackage Views
 * @author Heron Web Ltd
 * @copyright BrandTracker
 */
class E404View extends React.Component {

	/**
	 * Render.
	 * 
	 * @return {ReactNode}
	 */
	render() {
		return (
			<GenericView
				title="Not Found"
				caption="Nothing lives at this URL."
				icon={ErrorIcon} />
		);
	}

}

export default E404View;
